import { FC, useEffect, useState } from 'react';
import { format } from 'date-fns';

import { DatePickerInput } from '../DatePickerInput/DatePickerInput';
import { TimePickerInput } from '../TimePickerInput/TimePickerInput';

import './DateTimePicker.scss';
import { FormErrors } from '../../SharedTypes/Models';

export type Props = {
	orderId: number | undefined;
	date: Date;
	dateTimeChanged: (newPickupTime: string) => void;
	errors: FormErrors;
};


export const DateTimePicker:  FC<Props> = ({orderId, date, dateTimeChanged, errors}) => {
	const [pickupTime, setPickupTime] = useState<string>('Vælg tid');
	const [pickupDate, setPickupDate] = useState<string>('Vælg dato');

	const handleDateChanged = (newDate: Date) => {
		setPickupDate(format(newDate, 'yyyy-MM-dd'));
		dateTimeChanged(format(newDate, 'yyyy-MM-dd') + ' ' + pickupTime);
	}


	const handleTimeChanged = (newTime: string) => { 
		setPickupTime(newTime);
		dateTimeChanged(pickupDate + ' ' + newTime);
	}

	useEffect(() => {
		if(date.getDate()){
			setPickupTime(format(date, 'HH:mm'));
			setPickupDate(format(date, 'yyyy-MM-dd'));
		}
	}, [date]);

	useEffect(() => {
		if(!orderId){
			setPickupTime('Vælg tid');
			setPickupDate('Vælg dato');
		}
	}, [orderId]);

	
	return(
		<div className='c-dateTimePicker'>
			<div className='selector__wrapper'>
				<DatePickerInput
					defaultValue={pickupDate}
					inputChanged={(newDate) => handleDateChanged(newDate)}
				/>
				<TimePickerInput 
					value={pickupTime} 
					handleChanged={(time) => handleTimeChanged(time)}
				/>
			</div>
			<span className='TextInputError'>
				{errors.pickupTime}
			</span>
		</div>
	);
};

